import { useEffect, useState } from "react";

/**
 * Returns false for `delayMs`, then true.
 *
 * Loaders are mounted the instant a request starts, so a fast response paints a
 * loading screen for two frames and rips it away again. That flash is what
 * makes a quick action feel slow. Holding the render back means work that
 * finishes inside the delay never shows a loader at all.
 */
const useDelayedReveal = (delayMs = 200) => {
  const [isRevealed, setIsRevealed] = useState(delayMs <= 0);

  useEffect(() => {
    if (delayMs <= 0) {
      setIsRevealed(true);
      return;
    }

    setIsRevealed(false);
    const timer = setTimeout(() => setIsRevealed(true), delayMs);
    return () => clearTimeout(timer);
  }, [delayMs]);

  return isRevealed;
};

export default useDelayedReveal;
